var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRanks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6335 69.6411H3.51884C1.85243 69.6411 0.5 72.1825 0.5 75.3138V92.1352C0.5 92.7554 0.773729 93.2697 1.10377 93.2697H11.7381C11.6737 92.9218 11.6335 92.5285 11.6335 92.1352V69.6411ZM4.52512 87.5916C4.52512 88.2179 4.25468 88.7261 3.92135 88.7261C3.58802 88.7261 3.31758 88.2179 3.31758 87.5916V82.207C3.31758 81.5806 3.58802 81.0724 3.92135 81.0724C4.25468 81.0724 4.52512 81.5806 4.52512 82.207V87.5916ZM4.52512 77.8564C4.52512 78.4828 4.25468 78.991 3.92135 78.991C3.58802 78.991 3.31758 78.4828 3.31758 77.8564V76.8253C3.31758 76.1989 3.58802 75.6908 3.92135 75.6908C4.25468 75.6908 4.52512 76.1989 4.52512 76.8253V77.8564Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3739 56.439H15.8606C14.1959 56.439 12.8418 58.9843 12.8418 62.1116V92.1325C12.8418 92.7589 13.1122 93.267 13.4456 93.267H25.789C26.1223 93.267 26.3928 92.7589 26.3928 92.1325V62.1116C26.3928 58.9843 25.0386 56.439 23.3739 56.439ZM23.5752 87.5944C23.5752 88.2207 23.3047 88.7289 22.9714 88.7289C22.6381 88.7289 22.3676 88.2207 22.3676 87.5944V74.3478C22.3676 73.7214 22.6381 73.2132 22.9714 73.2132C23.3047 73.2132 23.5752 73.7214 23.5752 74.3478V87.5944ZM23.5752 69.9367C23.5752 70.563 23.3047 71.0712 22.9714 71.0712C22.6381 71.0712 22.3676 70.563 22.3676 69.9367V66.6498C22.3676 66.0234 22.6381 65.5152 22.9714 65.5152C23.3047 65.5152 23.5752 66.0234 23.5752 66.6498V69.9367Z",
    fill: "#FBBF24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7193 69.6411C34.0529 69.6411 27.6047 69.6411 27.6047 69.6411V92.1352C27.6047 92.5285 27.5644 92.9218 27.5 93.2697H38.1344C38.4644 93.2697 38.7381 92.7554 38.7381 92.1352C38.7381 92.1352 38.7381 78.4451 38.7381 75.3138C38.7381 72.1825 37.3857 69.6411 35.7193 69.6411ZM35.9206 87.5916C35.9206 88.2179 35.6501 88.7261 35.3168 88.7261C34.9835 88.7261 34.713 88.2179 34.713 87.5916V82.207C34.713 81.5806 34.9835 81.0724 35.3168 81.0724C35.6501 81.0724 35.9206 81.5806 35.9206 82.207V87.5916ZM35.9206 77.8564C35.9206 78.4828 35.6501 78.991 35.3168 78.991C34.9835 78.991 34.713 78.4828 34.713 77.8564V76.8253C34.713 76.1989 34.9835 75.6908 35.3168 75.6908C35.6501 75.6908 35.9206 76.1989 35.9206 76.8253V77.8564Z",
    fill: "#822727"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7536 86.4099V90.5665H45.1284C44.4721 90.5665 44.2533 91.004 44.2533 91.4415V93.1917C56.723 93.1917 69.1926 93.1917 81.6623 93.1917V91.4415C81.6623 91.004 81.2247 90.5665 80.7872 90.5665H77.9432V86.4099C77.9432 84.8786 76.6307 83.566 75.0993 83.566H66.7862V71.7526C71.3803 70.0025 74.443 67.1585 77.287 63.4395C82.9749 63.877 88.0065 62.7832 92.3818 59.0642C98.0697 54.0326 100.039 46.3758 100.476 38.9377C100.695 37.4064 99.3823 36.0938 97.8509 36.0938H85.3813C85.3813 35.6563 85.3813 35.2187 85.3813 35C85.3813 33.4686 84.0687 32.156 82.7561 32.156C69.4114 32.156 56.2854 32.156 43.1595 32.156C41.6281 32.156 40.3155 33.4686 40.3155 35C40.3155 35.2187 40.3155 35.6563 40.3155 36.0938H28.0647C26.3145 36.0938 25.2207 37.4064 25.2207 38.9377C25.6582 46.3758 27.6271 54.0326 33.315 59.0642C37.6904 62.7832 42.9407 63.877 48.6286 63.4395C51.2538 67.1585 54.3165 70.0025 58.9106 71.7526V83.566H50.5975C49.0662 83.566 47.7536 84.8786 47.7536 86.4099ZM71.599 45.9382L65.2548 45.5007L62.8484 39.594L60.442 45.5007L54.0978 45.9382L59.1294 49.876L57.598 56.2202L62.8484 52.72L68.3176 56.2202L66.7862 49.876L71.599 45.9382ZM35.9402 56.0015C31.7837 52.2825 30.0335 46.3758 29.3773 40.9066C29.1585 40.4691 29.596 39.8128 30.2523 39.8128H40.5343C41.1906 47.4696 42.722 52.9388 46.2222 59.5017C42.2844 59.5017 39.0029 58.8454 35.9402 56.0015ZM89.7566 56.0015C86.6939 58.8454 83.4124 59.5017 79.4746 59.5017C83.1936 52.9388 84.5062 47.2508 85.1625 39.8128H95.6633C96.1008 39.8128 96.5383 40.4691 96.5383 40.9066C95.6633 46.3758 94.1319 52.2825 89.7566 56.0015Z",
    fill: "url(#paint0_linear_12833_95093)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4549 25.1356L38.4021 21.8833C37.8613 21.3066 36.957 21.2841 36.3846 21.8271C35.8112 22.372 35.7861 23.2819 36.3279 23.8605L39.3788 27.109C39.6604 27.4086 40.0377 27.5603 40.4169 27.5603C40.7691 27.5603 41.1213 27.4292 41.3973 27.1671C41.9697 26.6222 41.9958 25.7122 41.4549 25.1356Z",
    fill: "url(#paint1_linear_12833_95093)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7591 14.0035C53.9315 14.6556 54.5434 15.0904 55.216 15.0904C55.3383 15.0904 55.4617 15.0772 55.586 15.0473C56.3908 14.8524 56.8784 14.0691 56.6747 13.2989L55.5263 8.95529C55.3227 8.187 54.5032 7.72416 53.6994 7.91342C52.8946 8.11017 52.4071 8.89158 52.6107 9.66362L53.7591 14.0035Z",
    fill: "url(#paint2_linear_12833_95093)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4854 15.0473C70.6032 15.0772 70.7201 15.0904 70.836 15.0904C71.4732 15.0904 72.0529 14.6556 72.2161 14.0035L73.3041 9.66362C73.497 8.89158 73.0351 8.11017 72.2727 7.91342C71.5149 7.72416 70.7349 8.187 70.542 8.95529L69.454 13.2989C69.2611 14.0691 69.723 14.8524 70.4854 15.0473Z",
    fill: "url(#paint3_linear_12833_95093)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_12833_95093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8697 18.7649C88.2982 18.2219 87.394 18.2444 86.8522 18.821L83.7994 22.0733C83.2586 22.65 83.2846 23.56 83.857 24.1048C84.1331 24.3669 84.4853 24.498 84.8375 24.498C85.2157 24.498 85.5939 24.3463 85.8755 24.0468L88.9264 20.7982C89.4682 20.2197 89.4431 19.3097 88.8697 18.7649Z",
    fill: "url(#paint4_linear_12833_95093)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_12833_95093",
    x: 25.1686,
    y: 30.6636,
    width: 75.3835,
    height: 64.0205,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0521166,
    dy: -1.49242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.746667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.973725 0 0 0 0 0.183529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0521166,
    dy: 1.49242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.746667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615196 0 0 0 0 0.468137 0 0 0 0 0.0882353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_12833_95093",
    x: 35.8854,
    y: 6.37867,
    width: 53.4831,
    height: 22.6741,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.0521166,
    dy: -1.49242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.746667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.973725 0 0 0 0 0.183529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.0521166,
    dy: 1.49242
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.746667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615196 0 0 0 0 0.468137 0 0 0 0 0.0882353 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_12833_95093",
    x: 24.5442,
    y: 17.288,
    width: 28.6928,
    height: 14.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.3933,
    dy: -4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.194259 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.3933,
    dy: 4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521686 0 0 0 0 0.39698 0 0 0 0 0.0748235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_12833_95093",
    x: 41.1712,
    y: 3.72429,
    width: 26.9428,
    height: 15.5128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.3933,
    dy: -4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.194259 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.3933,
    dy: 4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521686 0 0 0 0 0.39698 0 0 0 0 0.0748235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_12833_95093",
    x: 58.0169,
    y: 3.72429,
    width: 26.724,
    height: 15.5128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.3933,
    dy: -4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.194259 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.3933,
    dy: 4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521686 0 0 0 0 0.39698 0 0 0 0 0.0748235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_12833_95093",
    x: 72.0169,
    y: 14.2258,
    width: 28.6928,
    height: 14.4191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.3933,
    dy: -4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.194259 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12833_95093"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -11.3933,
    dy: 4.1468
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.06222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.521686 0 0 0 0 0.39698 0 0 0 0 0.0748235 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_12833_95093",
    result: "effect2_innerShadow_12833_95093"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12833_95093",
    x1: 62.7916,
    y1: 31.0922,
    x2: 64.5194,
    y2: 92.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12833_95093",
    x1: 38.8854,
    y1: 21.3281,
    x2: 39.1071,
    y2: 27.4492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12833_95093",
    x1: 54.6389,
    y1: 7.74527,
    x2: 55.0755,
    y2: 14.9425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12833_95093",
    x1: 71.3755,
    y1: 7.74527,
    x2: 71.836,
    y2: 14.9395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12833_95093",
    x1: 86.3581,
    y1: 18.2658,
    x2: 86.5798,
    y2: 24.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B08619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEA2C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12833_95093"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanks);
export default __webpack_public_path__ + "static/media/Ranks.a701b78f2a78d7f4ac89af44e6d287cb.svg";
export { ForwardRef as ReactComponent };